import { DBEntity } from './db-entity.model';

export interface Option {
  name: string;
  key: string;
  placeholder?: string;
}

export interface FilterOption extends Option {
  helperText?: string;
  isCheckbox?: boolean;
  isMultiSelect?: boolean;
  isAutocomplete?: boolean;
  isPaginated?: boolean;
  isText?: boolean;
  autocompleteUrl?: string;
  searchCategory?: string;
  optionLabel?: string | string[];
  optionLabelSeparator?: string;
  optionValue?: string;
  isLoading?: boolean;
  options?: {
    id?: number | string | null;
    name: string;
    placeholder?: string;
    color?: string;
  }[];
  successCallback?: (res: any[]) => any[];
  isDateRange?: boolean;
  isDate?: boolean;
  isNumberRange?: boolean;
  minKey?: string;
  maxKey?: string;
  tooltip?: string;
}
